import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import HazardDetail from '../HazardDetail';

/**
 * Canonical observation detail route (/observations/:id).
 *
 * Mirrors IncidentDetail.js: reuses the parameterised HazardDetail so every
 * shared sub-feature (photos, documents, RCA, CAPA linking, closure) works
 * against the /api/observations endpoints via the `entity` prop, with the
 * injury/statutory-only UI hidden.
 */
const ObservationDetail = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate('/observations', { replace: true });
    }
  }, [id, navigate]);

  return <HazardDetail {...props} entity="observation" />;
};

export default ObservationDetail;
